import React, { SVGProps } from 'react'
const SvgShowHoverFilled = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#008379"
      fillRule="evenodd"
      stroke="#008379"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m21 13-.222.268C14.852 20.332 8.926 20.243 3 13c6-7.333 12-7.333 18 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#008379"
      stroke="#fff"
      strokeWidth={1.5}
      d="M12 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    />
  </svg>
)
export default SvgShowHoverFilled
